import React from 'react';

export const ComingSoonModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Fond sombre et flou qui ferme la modale si on clique dessus */}
      <div 
        className="absolute inset-0 bg-[#080410]/80 backdrop-blur-sm cursor-pointer"
        onClick={onClose}
      ></div>

      {/* Contenu de la modale */}
      <div className="relative bg-[#0a0f1e] border border-[#00e5ff]/50 rounded-2xl p-8 max-w-lg w-full shadow-[0_0_30px_rgba(0,229,255,0.15)] animate-scaleIn z-10">
        <div className="text-center">
          <div className="text-5xl mb-4">🚀</div>
          <h3 className="font-outfit text-2xl sm:text-3xl font-bold mb-4 text-[#00e5ff]">
            Un instant d'anticipation !
          </h3>
          <p className="text-white/70 text-base sm:text-lg mb-8 leading-relaxed">
            Ce service incroyable se peaufine en coulisses. Laissez-nous un message en bas de page pour être prévenu en exclusivité dès son lancement. Votre patience sera récompensée !
          </p>
          <button 
            onClick={onClose}
            className="px-8 py-3 rounded-lg border border-[#00e5ff] text-[#00e5ff] font-semibold transition-all hover:bg-[#00e5ff]/10 hover:shadow-[0_0_15px_rgba(0,229,255,0.3)]"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};